import React, { useMemo, useState } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import regexp from '@/common/regexp';
import { categorizeServices, ItemNameId } from '@/components/elements/ManyItemsTooltip/CategorizedHint';

import { EllipsisText, ServiceItemWrapper, TextWithPoint } from './MultipleServicesSelector.styles';

export const MAX_SHOWED_BY_DEFAULT = 20;

interface Props {
  services?: ItemNameId[];
}

const ServicesList: React.FC<Props> = ({ services = [] }) => {
  const [hasShowMore, setHasShowMore] = useState(services.length > MAX_SHOWED_BY_DEFAULT);
  const categorizedServices = useMemo(() => categorizeServices(services
    ?.slice(0, hasShowMore ? MAX_SHOWED_BY_DEFAULT : undefined)), [services, hasShowMore]);

  return (
    <Box data-testId="services_list">
      {Object.keys(categorizedServices).map((categoryType) => {
        const services = categorizedServices[categoryType];
        return (
          <ServiceItemWrapper key={categoryType} data-testId={`services_of_category_${categoryType}`}>
            <Inscription weight="bold" lineHeight="20px">
              {capitalize(categoryType.replace(regexp.DASH_SYMBOL, ' '))} ({services.length}):
            </Inscription>
            {services.map((service) => (
              <TextWithPoint key={service?.id}>
                <EllipsisText lineHeight="20px" title={service?.name}>{service?.name}</EllipsisText>
              </TextWithPoint>
            ))}
          </ServiceItemWrapper>
        );
      })}
      {hasShowMore ? (
        <Inscription
          lineHeight="20px"
          color="textAccent"
          margin={{ top: 'spacing4' }}
          onClick={() => setHasShowMore(false)}
          style={{ cursor: 'pointer' }}
        >
          Show More Services ({services.length - MAX_SHOWED_BY_DEFAULT})
        </Inscription>
      ) : null}
    </Box>
  );
};

export default ServicesList;
